import React, { useEffect, useState } from 'react';
import { Container, Grid, Typography, Box, Paper } from '@mui/material';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import YachtCard from './YachtCard';
import { sortYachtsForDisplay } from '../utils/yachtSort';

const Home = () => {
  const [yachts, setYachts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchYachts = async () => {
      try {
        const yachtsData = (await getDocs(collection(db, 'yachts'))).docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }));
        setYachts(sortYachtsForDisplay(yachtsData));
      } catch {
        
      } finally {
        setLoading(false);
      }
    };

    fetchYachts();
  }, []);

  if (loading) return <Container><Typography>Ładowanie...</Typography></Container>;

  return (
    <Box>

      {/* Yachts Section */}
      <Box id="yachts-section" sx={{ py: 8, backgroundColor: '#f8f9fa' }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                color: '#1976d2',
                mb: 2,
                fontSize: { xs: '2rem', md: '2.5rem' }
              }}
            >
              Nasze Jachty
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#666',
                maxWidth: '600px',
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              Wybierz idealny jacht dla swojej przygody na Mazurach. 
              Wszystkie nasze jednostki są w doskonałym stanie technicznym.
            </Typography>
          </Box>

          <Grid container spacing={{ xs: 3, sm: 4 }}>
            {yachts.map((yacht) => (
              <Grid item key={yacht.id} xs={12} sm={6} md={4}>
                <YachtCard yacht={yacht} />
              </Grid>
            ))}
          </Grid>

          {yachts.length === 0 && (
            <Paper
              elevation={2}
              sx={{
                p: 6,
                textAlign: 'center',
                backgroundColor: 'white',
                borderRadius: 3
              }}
            >
              <Typography variant="h6" sx={{ color: '#666', mb: 2 }}>
                Brak dostępnych jachtów
              </Typography>
              <Typography variant="body1" sx={{ color: '#999' }}>
                Skontaktuj się z nami, aby poznać aktualną ofertę.
              </Typography>
            </Paper>
          )}
        </Container>
      </Box>
    </Box>
  );
};

export default Home; 